import React, { useState, useEffect } from 'react';
import vr from '../../../../utils/Verifiers';
import { fechaDiaCorto } from '../../../../utils/FechasTraductores';
import { getUser } from '../../../../utils/Common';

const AjusteTipoSemana = (p) => {
    const show_dialog = p.show_dialog ?? (() => { });
    const [config, setconfig] = useState({ estatus: 'Cargando', fecha: null, tipo_semana: 'Cargando', user: null });
    const [loader, setloader] = useState(false);
    //show_dialog = (title = "", body = "", type = 'error', size = "m")
    //fechaDiaCorto = (date, msj = "No disponible", conHora = false, separador = "-")
    useEffect(() => {
        getInfo();
    }, []);

    const getInfo = async () => {
        let resp = await vr.getDataAPI("dev/config_fechas", {}, setloader, false);
        if (!resp.estatus) {
            show_dialog("Error al cargar la configuración", resp.msj, "error");
            return;
        }
        setconfig({ ...resp });
    }

    const ajustarMetodoCalculo = async () => {
        let resp = await vr.getDataAPI("dev/ajuste_fechas", {}, setloader, false);
        show_dialog(resp.estatus ? "Ajuste exitoso" : "Error al ajustar el método de cálculo", resp.msj, resp.estatus ? "success" : "error");
        if (!resp.estatus) return;
        getInfo();

    }

    return (
        <div className='bw-1200 bg-white3 round-s shadow-multi mt-5 mb-5 p-2' style={{ maxHeight: '300px', position: 'relative', overflowY: 'auto' }}>
            <div className='row justify-content-evenly w-100 m-0 p-2'>
                <div className='w-90 m-0 p-1 mb-2 border-bottom h4 border-warning text-center'>Configuración de conversion de semanas</div>
                <div className='w-100 p-0 m-0' />
                <div className='w-100 ps-3 text-l'> Actualizado:
                    <span className='ms-1 text-bold'>{fechaDiaCorto(config.fecha, "No disponible", true)}</span>
                </div>
                <div className='w-100 ps-3 text-l'> Actualizado por:
                    <span className='ms-1 text-bold'>{(config.user ?? '').toUpperCase()}</span>
                </div>
                <div className='w-100 ps-3 text-l'> Configuración actual:
                    <span className='ms-1 text-bold'>{(config.tipo_semana ?? '').toUpperCase()}</span>
                </div>
                <div className='w-90 p-0 m-0 border-bottom border-warning mb-2' />
                <div className='col-auto mb-3 mt-3'>
                    <button className='btn btn-warning shadow ps-5 pe-5 text-bold text-pink4 border scale-025 round-xxl border border-dark'
                        disabled={[1, 3].includes(getUser().perfilId) ? false : true}
                        onClick={ajustarMetodoCalculo}
                    >Aternar metodo de calculo</button>
                </div>
            </div>
            {loader && <div className='blur-s w-100 h-100 round-m bg-white4' style={{ position: 'absolute', left: 0, top: 0 }}><div className='loader-local'></div></div>}
        </div>
    )
}

export default AjusteTipoSemana;